import { getRequestErrorMessage } from '../../lib/api/get-request-error-message';

const ALREADY_EXECUTING_CAUSES = new Set([
  'proposal_already_executing',
  'transaction_already_executing',
]);

/**
 * Identifies the backend's concurrency guard without treating unrelated
 * request failures as benign conflicts.
 */
export function isAlreadyExecutingError(error: unknown): boolean {
  return ALREADY_EXECUTING_CAUSES.has(getRequestErrorMessage(error, ''));
}
